/**
 * @packageDocumentation
 * @module Object
 */
import { convertDotNotationToArrayOfPath } from './convertDotNotationToArrayOfPath';
import { assert } from '../../others';
/**
 * This function is responsible for checking the type of the path and deciding the correct operation. If that path given is string, then it will be converted to array of paths using our helper function. If the path given is not string, it simply returns the path.
 *
 * @param {string | string[]} path
 *
 * @return {any}
 */
export var normalisePath = function (path) {
    if (typeof path === 'string') {
        return convertDotNotationToArrayOfPath(path);
    }
    assert(Array.isArray(path), "Path given should be a string or an array " + typeof path + " given!");
    return path;
};
//# sourceMappingURL=normalisePath.js.map